import React, { useEffect, useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { HOUSE_OPERATOR } from "@/lib/brand";
import { ServicePageHeader } from "@/components/ServiceHistoryButton";
import { toast } from "sonner";
import { PhoneCall } from "lucide-react";

export default function OtherOperators() {
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [operator, setOperator] = useState("all");
  const [selected, setSelected] = useState(null);
  const [phone, setPhone] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/products", { params: { category: "ricarica" } }).then((r) => setProducts((r.data || []).filter((p) => p.operator && p.operator !== HOUSE_OPERATOR))).catch(() => {});
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  const operators = ["all", ...Array.from(new Set(products.map((p) => p.operator)))];
  const filtered = operator === "all" ? products : products.filter((p) => p.operator === operator);

  const checkout = async () => {
    if (!selected) { toast.error("Seleziona un taglio di ricarica"); return; }
    if (!phone) { toast.error("Inserisci il numero di telefono"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/wallet/pay", { product_id: selected, quantity: 1, phone_number: phone, customer_id: customerId || null });
      toast.success(`Ricarica completata! Scalati ${euro(data.amount)} dal Plafond servizi.`);
      setSelected(null); setPhone("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="service-page-wide space-y-5 w-full max-w-none" data-testid="other-operators-page">
      <ServicePageHeader service="ricariche">
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizi pubblici</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Ricarica Altri Operatori</h1>
      </ServicePageHeader>
      <Card className="topup-layout p-5 glow-border">
        <div className="topup-fields space-y-4">
          <div>
            <Label>Cliente (opzionale)</Label>
            <Select value={customerId} onValueChange={setCustomerId}>
              <SelectTrigger className="mt-1.5" data-testid="other-ricarica-customer-select"><SelectValue placeholder="Associa a un cliente" /></SelectTrigger>
              <SelectContent>{customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label htmlFor="other-ricarica-phone">Numero di telefono</Label><Input type="tel" id="other-ricarica-phone" className="mt-1.5" data-testid="other-ricarica-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+39 3xx xxxxxxx" /></div>
        </div>
        <div className="topup-offers space-y-4"><div>
          <Label>Operatore</Label>
          <Select value={operator} onValueChange={(v) => { setOperator(v); setSelected(null); }}>
            <SelectTrigger className="mt-1.5" data-testid="other-operator-select"><SelectValue /></SelectTrigger>
            <SelectContent>{operators.map((o) => <SelectItem key={o} value={o}>{o === "all" ? "Tutti gli operatori" : o}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <Label>Taglio ricarica</Label>
          <div className="topup-offer-grid gap-3 mt-2">
            {filtered.map((p) => (
              <button key={p.id} type="button" data-testid={`other-ricarica-option-${p.id}`} onClick={() => setSelected(p.id)}
                className={`rounded-xl border p-4 text-center transition-all ${selected === p.id ? "border-primary bg-primary/10 ring-2 ring-primary" : "border-border hover:border-primary/50"}`}>
                <p className="font-head text-xl font-bold">{euro(p.price)}</p>
                <p className="text-xs text-muted-foreground mt-1">{p.operator}</p>
              </button>
            ))}
          </div>
        </div>
        </div>
        <Button onClick={checkout} disabled={loading} className="topup-submit gap-2" data-testid="other-ricarica-checkout-button">
          <PhoneCall className="w-4 h-4" /> {loading ? "Attendi…" : "Paga con Plafond"}
        </Button>
      </Card>
    </div>
  );
}
